<template>
  <div class="app-icon-picker">
    <q-icon
      :name="value"
      class="icon icon_big"
      size="14px"
    />
    <div class="angle">
      <q-icon
        :color="disabled ? 'grey' : 'primary'"
        :class="['icon', 'icon_big', { 'cursor-pointer': !disabled }]"
        name="fa fa-angle-down"
        size="14px"
      >
        <q-popup-proxy
          v-if="!disabled"
          ref="popupProxy"
          transition-hide="scale"
          transition-show="scale"
          :offset="[110, -115]"
          @show="onShow"
        >
          <div class="form">
            <AppInput
              ref="search"
              v-model="query"
              class="search"
              :placeholder="$t('placeholder.findIcon')"
            />

            <div class="icons">
              <q-virtual-scroll
                style="max-height: 160px"
                :virtual-scroll-item-size="40"
                :items="result"
              >
                <template v-slot="{ item, index }">
                  <q-item :key="index">
                    <q-icon
                      v-for="icon in item"
                      :key="icon"
                      :name="icon"
                      class="icon"
                      size="14px"
                      @click="selectIcon(icon)"
                    />
                  </q-item>
                </template>
              </q-virtual-scroll>
            </div>
          </div>
        </q-popup-proxy>
      </q-icon>
    </div>
  </div>
</template>

<script>
import AppInput from 'common/components/AppInput';
import icons from 'common/helpers/data/fontawesomeIcons.json';

const CHUNK_SIZE = 5;

export default {
  name: 'AppIconPicker',
  components: {
    AppInput,
  },
  props: {
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      query: undefined,
    };
  },
  computed: {
    result() {
      let filteredIcons = [];
      const result = [];

      if (this.query) {
        filteredIcons = Object.freeze(icons.all.filter((_) => _.includes(this.query)));
      } else {
        filteredIcons = Object.freeze(icons.all);
      }

      for (let index = 0; index < filteredIcons.length; index += CHUNK_SIZE) {
        result.push(filteredIcons.slice(index, index + CHUNK_SIZE));
      }
      return result;
    },
  },
  methods: {
    selectIcon(icon) {
      this.$refs.popupProxy.hide();
      this.$emit('input', icon);
    },
    onShow() {
      this.$nextTick(() => this.$refs.search.focus());
    },
  },
};
</script>

<style scoped lang="scss">
.app-icon-picker {
  width: 103px;
  border-radius: $radius-10;
  border: 1px solid $grey-2;
  height: 50px;
  display: flex;
  background: #fff;

  .angle {
    border-left: 1px solid $grey-2;
    padding-left: 0 !important;
  }
}
.search {
  max-width: 200px;
  min-width: 200px;
}
.form {
  padding: 10px;
}
.icons {
  .q-item {
    padding: 0;

    .q-icon {
      border-radius: $radius-6;

      &:hover {
        cursor: pointer;
        background: $grey-1;
        color: #fff;
        transition: all 0.5s ease;
      }
    }
  }
}
.icon {
  color: #626262;
  padding: 13px;
  transition: all 0.5s ease;

  &_big {
    padding: 18px;
  }
}
</style>
